import { SxProps, Theme } from '@mui/material/styles';

export const popperSx: SxProps<Theme> = { zIndex: 1300 };

export const confidenceRowSx: SxProps<Theme> = { display: 'flex', alignItems: 'center', gap: 0.5 };

export const confidenceLabelSx: SxProps<Theme> = { color: 'text.secondary', fontSize: '0.78rem' };

export const confidenceValueSx: SxProps<Theme> = { fontWeight: 600, fontSize: '0.78rem' };

export const commentaryListSx: SxProps<Theme> = { m: 0, pl: 2.5, mt: 0.5 };

// Settled-state line for a reviewed finding: same icon + label treatment as the
// review panel's Reviewed card (ReviewCard.styles statusLabelSx), so the popover
// and the panel read as one system.
export const settledStatusSx = (accepted: boolean): SxProps<Theme> => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.25,
  fontSize: '0.7rem',
  fontWeight: 600,
  color: accepted ? 'success.main' : 'error.main',
});
